import React, { memo, useMemo } from 'react';
import { createUseStyles, Modal, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import BetaBadge from 'components/BetaBadge';
import { CopilotChat } from 'shards/Copilot';
import CopilotIcon from 'shards/Copilot/CopilotChat/components/CopilotIcon';
import CopilotDisclaimer from 'shards/Copilot/CopilotDisclaimer';

import styles from './styles';

const useStyles = createUseStyles(styles, 'CopilotModal');

const CopilotModal = memo(({ chatSetup, onClose, open, title }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();

    const chatProps = useMemo(
        () => ({
            ...chatSetup,
            className: classes.chat,
        }),
        [chatSetup, classes.chat],
    );

    const modalContent = useMemo(
        () => (open ? <CopilotChat {...chatProps} /> : null),
        [chatProps, open],
    );

    const modalTitle = useMemo(
        () => (
            <div className={classes.titleContainer}>
                <div className={classes.titleLogo}>
                    <CopilotIcon />
                </div>
                <div className={classes.titleCopy}>
                    <div className={classes.title}>
                        <Text type="h6" bold>
                            {t('label_danai_golderminute_title')}
                        </Text>
                        <BetaBadge />
                    </div>
                    {title}
                </div>
            </div>
        ),
        [classes.titleContainer, classes.titleLogo, classes.titleCopy, classes.title, t, title],
    );

    const modalProps = useMemo(
        () => ({
            children: modalContent,
            className: classes.root,
            footerComponent: <CopilotDisclaimer className={classes.footer} />,
            height: '90%',
            width: 690,
            isOpen: open,
            onRequestClose: onClose,
            overrides: {
                content: {
                    style: {
                        height: '100%',
                    },
                },
            },
            title: modalTitle,
        }),
        [modalContent, classes.root, classes.footer, open, onClose, modalTitle],
    );

    return <Modal {...modalProps} />;
});

export default CopilotModal;
